import { render, staticRenderFns } from "./MessengerIndicatorModule.vue?vue&type=template&id=0b75d9c3&scoped=true&"
import script from "./MessengerIndicatorModule.vue?vue&type=script&lang=js&"
export * from "./MessengerIndicatorModule.vue?vue&type=script&lang=js&"
import style0 from "./MessengerIndicatorModule.vue?vue&type=style&index=0&id=0b75d9c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b75d9c3",
  null
  
)

export default component.exports